import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { ProductQueryParams, ProductReportListResponse } from '@frontend/product/types';

export class ProductReportClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    public static async fetchReportProduct(queryParams?: ApiQueryParams<DefaultQueryParams & ProductQueryParams>): Promise<ProductReportListResponse> {
        return await this.apiPaginated<ProductReportListResponse, DefaultQueryParams & ProductQueryParams>(`${this.endpoint}/report-products`, queryParams);
    }
}
